import { render, staticRenderFns } from "./DesktopMenuTopLevel.vue?vue&type=template&id=67a525cd&"
import script from "./DesktopMenuTopLevel.vue?vue&type=script&lang=js&"
export * from "./DesktopMenuTopLevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports